export default function Preloader() {
    const preloader = document.querySelector('.preloader');
    const main = document.querySelector('#main');

    if (!preloader) return;

    // Function to hide preloader
    const hidePreloader = () => {
        preloader.classList.add('hidden');
        document.body.classList.remove('loading');
        if (main) main.style.opacity = '1';

        // Remove preloader from DOM after animation
        setTimeout(() => {
            preloader.remove();
        }, 500);
    };

    // Hide preloader when all content is loaded
    if (document.readyState === 'complete') {
        hidePreloader();
    } else {
        window.addEventListener('load', hidePreloader);
    }
}
